import { Controller } from "@hotwired/stimulus"
import { render } from "react-dom"

import Iframe from "web/components/Iframe"

export default class IFrameController extends Controller {
  static values = {
    title: String,
    content: String,
  }

  connect() {
    render(
      <Iframe title={this.titleValue} content={this.contentValue} />,
      this.element
    )
  }

  preventMorphing(event) {
    event.preventDefault()
  }
}
